import { render, staticRenderFns } from "./page-wrap.vue?vue&type=template&id=97efd1ce&scoped=true&"
import script from "./page-wrap.vue?vue&type=script&lang=ts&"
export * from "./page-wrap.vue?vue&type=script&lang=ts&"
import style0 from "./page-wrap.vue?vue&type=style&index=0&id=97efd1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97efd1ce",
  null
  
)

export default component.exports